import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const OrgOnboardingPage = lazy(() => import('~/features/platform/pages/org-onboarding-page'));

export const Route = createFileRoute('/_authenticated/_tenant/platform/subsidiaries/onboarding')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <OrgOnboardingPage />
    </Suspense>
  ),
});
